import { render, staticRenderFns } from "./reportFeeDetailCar.vue?vue&type=template&id=53d1654e&scoped=true"
import script from "./reportFeeDetailCar.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailCar.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailCar.vue?vue&type=style&index=0&id=53d1654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1654e",
  null
  
)

export default component.exports